module.exports = __webpack_public_path__ + "img/t.me.b08e60c1.svg";